import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CartDrawer } from "./CartDrawer";
import { ChatWidget } from "./ChatWidget";

export default function StoreLayout() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const ref = new URLSearchParams(search).get("ref");
    if (ref) localStorage.setItem("ddv_ref", ref.toUpperCase());
  }, [pathname, search]);
  return (
    <div className="shopee min-h-screen">
      <Header />
      <main key={pathname} className="rise">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <ChatWidget />
    </div>
  );
}
